import { useReducer } from 'react';

const reducer = (state, action) => {
  switch (action.type) {
    case 'info':
      return {
        ...state,
        username: action.payload.username,
        password: action.payload.password,
        remember: action.payload.remember,
      };
    case 'message':
      return { ...state, password: '', message: action.payload };
    case 'twofactor':
      return {
        ...state,
        twofactor: true,
        twofactorValidationToken: action.payload.validationToken,
        twofactorUserId: action.payload.userId,
      };
    default:
      return state;
  }
};

export const useLoginReducer = () =>
  useReducer(reducer, {
    username: '',
    password: '',
    message: '',
    remember: false,
    twofactor: false,
    twofactorVerificationCode: '',
    twofactorUserId: 0,
  });
